import styled from "styled-components";

export const WebhookContainer = styled.div`
  max-width: 80rem;
  width: 100%;
  height: auto;
  margin: 2rem auto;
`;

export const WebhookContent = styled.div`
  margin-top: 1.5rem;
`;

export const WebhookTitle = styled.h1`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 400px;
  color: ${({ theme }) => theme.controlPanel?.textControlPanel};
  font: 600 1.25rem/1.875rem "Inter";
  margin: 0;
`;
